import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import LoaderSpin from "../Common/LoaderSpin";
import { getAccessToken } from "../../services/authService";

// Landing page for organisation team invitation links. The recipient must be
// signed in with a verified account owning the invited email address; anyone
// else is guided to register or sign in first.
const AcceptOrganisationInvite = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState({ busy: true, error: "", organisation: "" });

  useEffect(() => {
    const accept = async () => {
      const token = getAccessToken();
      if (!token) {
        setState({ busy: false, error: "Please sign in or register with your invited email address, then open this link again.", organisation: "" });
        return;
      }
      try {
        const res = await fetch(`${process.env.REACT_APP_DEV_API}/account/organisation/invites/accept`, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
          body: JSON.stringify({ code }),
        });
        const body = await res.json();
        if (!res.ok) throw new Error(body.message || "This invitation could not be accepted.");
        setState({ busy: false, error: "", organisation: body.data?.organisation || "" });
      } catch (error) {
        setState({ busy: false, error: error.message, organisation: "" });
      }
    };
    accept();
  }, [code]);

  if (state.busy) {
    return <div className="h-full flex justify-center items-center"><LoaderSpin size={36} loading={true} /></div>;
  }

  return (
    <div className="h-full flex justify-center items-center">
      <div className="max-w-md w-full bg-white rounded-xl shadow p-8 text-center space-y-4">
        {state.organisation ? (
          <>
            <h1 className="text-xl font-bold">Welcome to {state.organisation}</h1>
            <p>Your team access is now active.</p>
            <button className="bg-[#337ab7] text-white rounded-lg px-6 py-2" onClick={() => navigate("/home", { replace: true })}>Go to your Dashboard</button>
          </>
        ) : (
          <>
            <h1 className="text-xl font-bold">Invitation</h1>
            <p role="alert">{state.error}</p>
            <p><Link className="text-[#337ab7] underline" to="/signin">Sign in</Link> or <Link className="text-[#337ab7] underline" to="/register">register</Link> with your invited email address, then open your invitation link again.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AcceptOrganisationInvite;
